// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'
import AnimatedArrow from '/react4xp/components/AnimatedArrow'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import { GeneralClock, GeneralStar } from '/react4xp/components/Svg/Icons/General'

// prop types
interface RecipeCardProps {
    href?: string
    external?: boolean
    src?: string
    srcMedium?: string
    alt?: string
    width?: number
    sizes?: string
    title?: string
    time?: string
    rating?: string
    desc?: string
    className?: string
}

export default function RecipeCard({
    href,
    external,
    src,
    srcMedium,
    alt,
    width,
    sizes,
    title,
    time,
    rating,
    desc,
    className,
    ...rest
}: RecipeCardProps) {
    return (
        <a
            href={href}
            target={external ? '_blank' : undefined}
            className={clsx(
                'recipe-card',
                className
            )}
            {...rest}
        >
            <div className='recipe-card__mask'>

                <div className={clsx(
                    'recipe-card__image',
                    !src && 'recipe-card__image--no-image'
                )}>
                    {src && (
                        <Image
                            src={src}
                            srcMedium={srcMedium}
                            alt={alt}
                            width={width}
                            sizes={sizes}
                            className='cover'
                        />
                    )}
                </div>

                <div className='recipe-card__wrapper'>

                    {isNonWhitespaceString(title) && (
                        <h3 className='recipe-card__wrapper__title h4'>
                            {title}
                        </h3>  
                    )}

                    {(time || rating) && (
                        <div className='recipe-card__wrapper__icons text-small'>

                            {isNonWhitespaceString(time) && (
                                <span className='recipe-card__wrapper__icons__item'>
                                    <GeneralClock variant='white' />
                                    <span>
                                        {time}
                                    </span>
                                </span>
                            )}

                            {/*
                            <span className='recipe-card__wrapper__icons__item'>
                                <GeneralStar variant='white' />
                                <span>
                                    {rating ? rating : '--'}
                                </span>
                            </span>
                            */}

                        </div>
                    )}

                    {isNonWhitespaceString(desc) && (
                        <div
                            className='recipe-card__wrapper__desc'
                            dangerouslySetInnerHTML={{ __html: desc }}
                            suppressHydrationWarning
                        />
                    )}

                    <AnimatedArrow className='recipe-card__wrapper__arrow' />
                    
                </div>

            </div>

        </a>
    )
}